import { timerHelperModule } from '../../../../shared/app/helpers/timer-helper';

export const featureCarouselDirectiveModule = angular
  .module('Q.components.feature-carousel', [timerHelperModule])

  .directive('featureCarousel', function (timerHelper, $window) {
    return {
      restrict: 'A',
      link(scope, el, attr) {
        el.addClass('carousel-mode-enabled');
        const list = el.find('ul');
        const listItems = list.querySelectorAll('li');
        let totalItems = listItems.length;
        let headerSelector = angular.element(
          '<div class="feature-carousel-header-selector"></div>',
        );
        let headerItems;
        let autoFlipTimer;

        const stopFlipTimer = () => {
          timerHelper.runEvery.cancel(autoFlipTimer);
        };

        const select = (idx, stopFlipping = false) => {
          const active = list.getStyle('display') === 'flex';
          if (active) {
            listItems.removeClass('selected');
            headerItems.removeClass('selected');
            listItems.eq(idx).addClass('selected');
            headerItems.eq(idx).addClass('selected');
            listItems.css({ transform: `translateX(-${idx}00%)` });
            headerSelector.css({
              left: `${(100 * idx) / totalItems}%`,
              width: `${100 / totalItems}%`,
            });
          } else {
            listItems.css({ transform: null });
          }
          if (stopFlipping || !active) {
            stopFlipTimer();
          }
        };

        // generate header
        const header = angular.element('<div class="feature-carousel-header">');
        angular.forEach(listItems, (listItem, idx) => {
          const headerItem = angular
            .element(listItem)
            .querySelector('h3')
            .clone();
          headerItem.on('click', () => select(idx, true));
          header.append(headerItem);
        });

        header.append(headerSelector);

        headerItems = header.querySelectorAll('h3');
        el.prepend(header);

        // set up selections
        let last = 0;
        select(last);
        let checkCounter = 0;
        autoFlipTimer = timerHelper.runEvery(() => {
          // if we have on-scroll-add-class, then wait until the element is visible before
          // animating, otherwise always animate
          if (
            attr.onScrollAddClass === undefined ||
            el.hasClass('is-visible')
          ) {
            checkCounter++;
            if (checkCounter === 12) {
              // 12 seconds
              last = (last + 1) % totalItems;
              select(last);
              checkCounter = 0;
            }
          } else {
            checkCounter = 0;
          }
        }, 1000);

        // if you click on an item, stop flipping
        listItems.on('click', stopFlipTimer);

        angular.element($window).on('resize', () => select(last));
      },
    };
  });
